
import { HttpService } from "@core/services/http.service.ts";
import { UserDeletionRequest } from "./userDeletionRequest.model.ts";
import { apiURL } from "@utils/environment.ts";

export class UserDeletionRequestService extends HttpService {
  private APIURL = apiURL;


  async createRequest(userId: string) {
    this.urlAPI = this.APIURL + "/user/" + userId;
    return this.doDelete<UserDeletionRequest>();
  }

  async getDeleteRequestById(id: string) {
    this.urlAPI = this.APIURL + "/user-delete-request/" + id;
    return this.doGet<UserDeletionRequest>();
  }

  async getRequests(params: Record<string, string | number>) {
    const searchParams = new URLSearchParams(params as any).toString();
    this.urlAPI = this.APIURL + "/user/deletion-requests?" + searchParams;
    return this.doGet<{ data: UserDeletionRequest[]; total: number }>();
  }
}

export const userDeletionRequestService = new UserDeletionRequestService();
